export const TYPE = {
    ADDRESS_LIST: 'ADDRESS_LIST',
    SET_LOADER: 'SET_LOADER'
}